module.exports = __webpack_public_path__ + "static/media/14-10.06357584.mp3";